<div class="radio-card ct-card interactive" (click)="onCardClick($event)">
  <label class="body" (click)="onLabelClick($event)">
    <input
      [type]="isMultiple() ? 'checkbox' : 'radio'"
      [name]="inputName()"
      [checked]="isSelected()"
      [disabled]="isDisabled()"
      (click)="onInputClick($event)"
      (change)="onSelect()"
      (blur)="onBlur()"
    />

    <div class="copy">
      <div class="title">
        @if (icon(); as iconValue) {
          <fa-icon class="icon" [icon]="iconValue" aria-hidden="true" />
        }
        <span class="label">{{ label() }}</span>
        <ng-content select="[radioCardBadge]" />
      </div>

      @if (price(); as priceText) {
        <p class="price">
          <span class="price-amount">{{ priceText }}</span>
          @if (priceHint(); as priceHintText) {
            <span class="price-hint">{{ priceHintText }}</span>
          }
        </p>
      }

      @if (sublabel(); as sublabelText) {
        <p class="sublabel">{{ sublabelText }}</p>
      }

      @if (description(); as descriptionHtml) {
        <div class="description" [innerHTML]="descriptionHtml"></div>
      }
    </div>
  </label>

  <div class="action">
    <ng-content select="[radioCardAction]" />
  </div>

  <div class="footer">
    <ng-content select="[radioCardFooter]" />
  </div>

  <ng-content />
</div>
